import { makeAction, makeReducer } from '@finn-no/redux-actions';
import type { FlightSearchForm } from '../../types/search';

const actions = {
    allFieldsChanged: makeAction<FlightSearchForm>('FLIGHT/ALL_FIELDS_CHANGED', (state, { payload }) => ({ ...state, ...payload })),
    setTripType: makeAction<FlightSearchForm>('FLIGHT/SET_TRIP_TYPE', 'tripType'),
    setDates: makeAction<FlightSearchForm>('FLIGHT/SET_DATES', (state, { payload }) => ({
        ...state,
        departureDate: payload.startDate ?? null,
        returnDate: payload.endDate ?? null,
    })),
    setCabinType: makeAction<FlightSearchForm>('FLIGHT/SET_CLASS_TYPE', 'cabinType'),
    setOrigin: makeAction<FlightSearchForm>('FLIGHT/SET_ORIGIN', (state, { payload }) => ({
        ...state,
        origin: payload?.id ?? null,
        originName: payload?.text ?? null,
        originCity: payload?.city ?? null,
        originCountry: payload?.country ?? null,
    })),
    setDestination: makeAction<FlightSearchForm>('FLIGHT/SET_DESTINATION', (state, { payload }) => ({
        ...state,
        destination: payload?.id ?? null,
        destinationName: payload?.text ?? null,
        destinationCity: payload?.city ?? null,
        destinationCountry: payload?.country ?? null,
    })),
    setOrigin2: makeAction<FlightSearchForm>('FLIGHT/SET_ORIGIN2', (state, { payload }) => ({
        ...state,
        origin2: payload?.id ?? null,
        originName2: payload?.text ?? null,
        originCity2: payload?.city ?? null,
        originCountry2: payload?.country ?? null,
    })),
    setDestination2: makeAction<FlightSearchForm>('FLIGHT/SET_DESTINATION2', (state, { payload }) => ({
        ...state,
        destination2: payload?.id ?? null,
        destinationName2: payload?.text ?? null,
        destinationCity2: payload?.city ?? null,
        destinationCountry2: payload?.country ?? null,
    })),
    swapOriginDestination: makeAction<FlightSearchForm>('FLIGHT/SWAP_ORIGIN_DESTINATION', (state) => ({
        ...state,
        origin: state.destination ?? null,
        originName: state.destinationName ?? null,
        originCity: state.destinationCity ?? null,
        originCountry: state.destinationCountry ?? null,
        destination: state.origin ?? null,
        destinationName: state.originName ?? null,
        destinationCity: state.originCity ?? null,
        destinationCountry: state.originCountry ?? null,
    })),
    swapOriginDestination2: makeAction<FlightSearchForm>('FLIGHT/SWAP_ORIGIN_DESTINATION2', (state) => ({
        ...state,
        origin2: state.destination2 ?? null,
        originName2: state.destinationName2 ?? null,
        originCity2: state.destinationCity2 ?? null,
        originCountry2: state.destinationCountry2 ?? null,
        destination2: state.origin2 ?? null,
        destinationName2: state.originName2 ?? null,
        destinationCity2: state.originCity2 ?? null,
        destinationCountry2: state.originCountry2 ?? null,
    })),
    setPassenger: makeAction<FlightSearchForm>('FLIGHT/SET_PASSENGER', (state, { payload }) => {
        const newState = { ...state, ...payload };
        const totalPassengers = newState.adults + newState.children + newState.infants;
        const invalidPassengerCount = totalPassengers > 9 || newState.adults < 1 || newState.children < 0;

        return invalidPassengerCount ? state : { ...newState };
    }),
};

export default actions;
export const reducer = makeReducer<FlightSearchForm>(actions);
